import { Sensor } from "@/global/interface/device/sensor";
import { graphicStore } from "@/global/store/graphic-store";
import { BlockT, ModelBase } from "pytha";
import { useEffect, useRef, useState } from "react";
import './sensor-pop-window.less'
import { ReactComponent as ArrowSvg } from '../icons/arrow-white-down.svg';
import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";
import { ReactComponent as RadioSvg } from '../icons/radio.svg';
import { ReactComponent as RadioSelecetdSvg } from '../icons/radio-selected.svg';
import { updateMonitorParameterDq } from "@/api/monitor-object/monitor-parameter";
import TnMessage from "@/global/components/message";
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";

interface IPosition {
    x: number,
    y: number
}
interface Iprops {
    entity: ModelBase // 传感器图元
    sensor: Sensor // 传感器信息
    param: MonitorParameter // 监测参数
}
export default function SensorPopWindow(props: Iprops) {
    const ref = useRef();
    const { sensor, param } = props;
    const [position, setPosition] = useState<IPosition>(null); // 气泡窗位置
    const [selectedSensorParamId, setSelectedSensorParamId] = useState<number>(); // 选中的传感器参数id

    // 监听位置移动
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onPanChanged.add(computePosition);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onRotateChanged.add(computePosition);
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onZoomChanged.add(computePosition);
        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onPanChanged.remove(computePosition);
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onRotateChanged.remove(computePosition);
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onZoomChanged.remove(computePosition);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()?.camera])

    // 监听传入图元
    useEffect(() => {
        if (!props?.entity) return;
        computePosition();
    }, [props.entity])

    // 计算弹窗位置
    const computePosition = () => {
        if (!props?.entity?.uuid) return;
        // 当前图元基点坐标
        let basePoint = (graphicStore.extraContext.getCurrentViewEditor().entityDict[props.entity.uuid] as BlockT).clone().position;
        // 转换为屏幕坐标
        basePoint.project(graphicStore.extraContext.getCurrentViewEditor().camera);
        let viewport = document.getElementById('viewport');
        let screenX = (basePoint.x + 1) * viewport.offsetWidth / 2;
        let screenY = (-basePoint.y + 1) * viewport.offsetHeight / 2;
        // 弹窗的宽
        let popupWidth = 136;
        // 传感器可选参数的数量
        let count = (sensor?.sensorParameters || []).length;
        // 弹窗的高
        let popupHeight = 25 * count + 8;
        let position = {
            x: screenX - popupWidth / 2,
            y: screenY - popupHeight - 8,
        };
        setPosition(position);
    }

    // 选择了某传感器的某参数
    const onSelectParam = (sensorParameterId) => {
        setSelectedSensorParamId(sensorParameterId);
        let data = {
            sensorId: sensor.id,
            sensorParameterId: sensorParameterId,
            sensorType: sensor.type,
            globalSensorId: sensor.globalSensorId,
        }
        updateMonitorParameterDq(param.id, data).then(res => {
            TnMessage.success("匹配成功")
            // 发信号
            emitter.emit(Emit_Event.MATCH_SENSOR_FINISH, { param, sensor });
        }).catch(err => {
            TnMessage.error("匹配失败")
        }).finally(() => {
            setSelectedSensorParamId(null);
        })
    }

    if (sensor == null) {
        return (<div></div>)
    }

    return (
        <div className="sensor-param-pop-window" ref={ref} style={{ display: 'flex', position: `absolute`, left: position?.x, top: position?.y }}>
            <div className="param-list">
                {sensor.sensorParameters.map((item, index) => (
                    <div className="param-item" key={index}>
                        {selectedSensorParamId == item.id && <RadioSelecetdSvg className="radio-icon" />}
                        {selectedSensorParamId != item.id && <RadioSvg className="radio-icon" onClick={() => onSelectParam(item.id)} />}
                        <div className="text">{sensor.code}-{item.name}{item.idx}</div>
                    </div>
                ))}
            </div>
            <ArrowSvg className="arrow-icon" />
        </div>
    )
}